import React from 'react';
import PropTypes from 'prop-types';

const VehiculosTable = ({ 
  columns, 
  data, 
  pageCount, 
  pageIndex, 
  onPageChange, 
  pageSize, 
  onPageSizeChange, 
  onRowClick, 
  loading,
  total,
  onEditClick,
  onDeleteClick,
  permisos 
}) => {

  // Renderizar cabecera
  const renderHeader = () => (
    <tr>
      {columns.map(col => (
        <th key={col.id || col.accessor}>{col.Header}</th>
      ))}
      {/* {(permisos?.canEdit || permisos?.canDelete) && <th>Acciones</th>} */}
    </tr>
  );

  // Renderizar filas
  const renderRows = () =>
    data.map((row, idx) => (
      <tr key={row.id || idx} style={{ cursor: 'pointer' }}>
        <td onClick={() => onEditClick && onEditClick(row)}>{row.ppu || ''}</td>
        <td onClick={() => onEditClick && onEditClick(row)}>{row.tipo_vehiculo?.tipo || '-'}</td>
        <td onClick={() => onEditClick && onEditClick(row)}>{row.usuarios_moviles_count || 0}</td>
        {/* {(permisos?.canEdit || permisos?.canDelete) && (
          <td onClick={(e) => e.stopPropagation()}>
            <div className="d-flex gap-1">
              {permisos?.canEdit && (
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => onEditClick && onEditClick(row)}
                  title="Editar"
                >
                  ✏️
                </button>
              )}
              {permisos?.canDelete && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => onDeleteClick && onDeleteClick(row.id)}
                  title="Eliminar"
                >
                  🗑️
                </button>
              )}
            </div>
          </td>
        )} */}
      </tr>
    ));

  // Renderizar paginación
  const renderPagination = () => (
    <div className="d-flex justify-content-between align-items-center mt-2">
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => onPageChange(0)}
          disabled={pageIndex === 0}
        >
          {'<<'}
        </button>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => onPageChange(pageIndex - 1)}
          disabled={pageIndex === 0}
        >
          {'<'}
        </button>
        <span style={{ minWidth: 90, textAlign: 'center' }}>
          Página <strong>{pageIndex + 1}</strong> de <strong>{pageCount}</strong>
        </span>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => onPageChange(pageIndex + 1)}
          disabled={pageIndex + 1 >= pageCount}
        >
          {'>'}
        </button>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => onPageChange(pageCount - 1)}
          disabled={pageIndex + 1 >= pageCount}
        >
          {'>>'}
        </button>
      </div>
      <div className="d-flex align-items-center gap-2">
        <span className="me-2">
          Total registros: <strong>{total}</strong>
        </span>
        <select
          value={pageSize}
          onChange={e => onPageSizeChange(Number(e.target.value))}
          className="form-select form-select-sm"
          style={{ width: 'auto', display: 'inline-block' }}
        >
          {[10, 20, 30, 50].map(size => (
            <option key={size} value={size}>
              Mostrar {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '120px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : (
        <>
          <table className="table table-hover" style={{ minWidth: '600px' }}>
            <thead>{renderHeader()}</thead>
            <tbody>
              {data.length > 0 ? (
                renderRows()
              ) : (
                <tr>
                  <td colSpan={columns.length + (permisos?.canEdit || permisos?.canDelete ? 1 : 0)} className="text-center">
                    No se encontraron vehículos
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {renderPagination()}
        </>
      )}
    </div>
  );
};

VehiculosTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  loading: PropTypes.bool,
  total: PropTypes.number.isRequired,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  permisos: PropTypes.object
};

export default VehiculosTable;
